module.exports = __webpack_public_path__ + "static/media/ElonMusk.5ad4b753.wav";